import * as z from "zod/v4";

export const uploadLinearFile = {
  name: "uploadLinearFile" as const,
  input: z.object({
    filename: z.string(),
    contentType: z.string(),
    // Base64 encoded file content
    fileContent: z.string(),
  }),
  output: z.object({
    success: z.boolean(),
    // The URL to use in markdown to reference this file
    url: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
